/*eslint-disable*/
import React from 'react';
import Carousel from 'react-elastic-carousel';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { imageUrl } from '../../config/apiUrl';
import classes from './ElasticCarousel.module.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const customBreakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2 },
  { width: 768, itemsToShow: 2 },
  { width: 1200, itemsToShow: 2 }
];
const ElasticCarousel = ({
  customClass,
  showArrows = true,
  pagination = false,
  customArrows = false,
  customLeftArrow,
  customRightArrow,
  images,
  navigateLink,
  breakPoints = customBreakPoints,
  className = '',
  ...props
}) => {
  const memoizeValue = React.useMemo(
    () => images?.map((e) => (e?.includes('https://') ? e : imageUrl(e))),
    [images]
  );
  const navigate = useNavigate();
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const isRTL = ['ar', 'fa'].includes(selectedLanguage);

  return (
    <>
      <style>
        {`
        .image-carousel .rec-slider-container{
            padding-block:0px;
            margin:0px;
        }
       

        .image-carousel .rec-carousel-wrapper{
            height:100%;
        }
        
        .image-carousel .rec-slider{
        }
     
        .${classes.image} .rec-arrow-left, .${classes.image} .rec-arrow-right{
          opacity:1;
        }
        .${classes.image}:hover .rec-arrow-left, .${classes.image}:hover .rec-arrow-right{
           box-shadow:none !important;
          opacity:1;
        }
          .image-carousel .rec-arrow-left{
            position: absolute;
            z-index: 1;
            left: 0px;
            height: 100%;
            top: 0;
            min-width:0px;
            width:30px;
            box-shadow:none;
            margin-inline-start:0px
        }
        .image-carousel .rec-arrow-right{
            position: absolute;
            right: 0px;
            height: 100%;
            min-width:0px;
            width:30px;
            top: 0;
            box-shadow:none;
            margin-inline-end:0px
        }
        .image-carousel .rec-item-wrapper{
            height:100%;
        }
        .rec-carousel-item{
          height:100%;
        }
        ${isRTL ? `
        /* Fix PhotoView in RTL mode */
        .image-carousel .rec-carousel-item [data-photo-view],
        .image-carousel .rec-carousel-item > div {
          direction: ltr !important;
          transform: none !important;
        }
        .image-carousel .rec-carousel-item img {
          display: block !important;
          visibility: visible !important;
          opacity: 1 !important;
          transform: none !important;
        }
        /* Fix PhotoView portal/overlay in RTL */
        body [class*="PhotoView"],
        body [class*="photo-view"],
        body [id*="photo-view"] {
          direction: ltr !important;
        }
        /* Reset any RTL transforms on carousel items */
        .image-carousel.rec-rtl .rec-carousel-item {
          transform: none !important;
        }
        .image-carousel.rec-rtl .rec-carousel-item > div {
          transform: none !important;
        }
        ` : ''}
        `}
      </style>
      <div className={[classes.image, customClass].join(' ')}>
        <div className={classes.invi_box} onClick={() => navigateLink && navigate(navigateLink)} />
        <PhotoProvider maskOpacity={0.75}>
          <Carousel
            {...(customArrows && {
              renderArrow: ({ type, onClick }) => (
                <div
                  className={[
                    customLeftArrow || customRightArrow ? classes.arrowWithoutBg : classes.arrow,
                    classes[type]
                  ].join(' ')}
                  onClick={onClick}>
                  {type === 'PREV' ? (
                    customLeftArrow ? (
                      customLeftArrow
                    ) : (
                      <FaArrowLeft color="var(--primary-clr)" />
                    )
                  ) : customRightArrow ? (
                    customRightArrow
                  ) : (
                    <FaArrowRight color="var(--primary-clr)" />
                  )}
                </div>
              )
            })}
            className={['image-carousel', className].join(' ')}
            breakPoints={breakPoints}
            pagination={pagination}
            showArrows={showArrows}
            isRTL={isRTL}
            {...props}>
            {memoizeValue.map((item, index) => {
              const wrapperStyle = {
                direction: 'ltr',
                height: '100%',
                width: '100%',
                position: 'relative'
              };
              if (isRTL) {
                wrapperStyle.transform = 'none';
              }
              return (
                <div key={index} style={wrapperStyle}>
                  <PhotoView src={item}>
                    <img 
                      src={item} 
                      alt="" 
                      draggable={false}
                      style={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </PhotoView>
                </div>
              );
            })}
          </Carousel>
        </PhotoProvider>
      </div>
    </>
  );
};

export default ElasticCarousel;
